export const FETCH_GROUPED_TRAINERS = 'FETCH_GROUPED_TRAINERS';
export const FETCH_TRAINER = 'FETCH_TRAINER';
export const FETCH_TRAINER_COURSE_MONTHLY_STATS = 'FETCH_TRAINER_COURSE_MONTHLY_STATS';
export const POST_TRAINER = 'POST_TRAINER';
export const PATCH_TRAINER = 'PATCH_TRAINER';
export const DELETE_TRAINER = 'DELETE_TRAINER';
export const WECHAT_UNBIND_TRAINER = 'WECHAT_UNBIND_TRAINER';



// WEBPACK FOOTER //
// ./src/store/trainer/types.js